export const flaggedFileDownloadHistoryListingConstants = {
    CLEAR_ALL_MESSAGE: 'CLEAR_ALL_MESSAGE',
    GETALLFLAGGEDFILEDOWNLOADHISTORYLISTING_REQUEST: 'GETALLFLAGGEDFILEDOWNLOADHISTORYLISTING_REQUEST',
    GETALLFLAGGEDFILEDOWNLOADHISTORYLISTING_REQUEST_END: 'GETALLFLAGGEDFILEDOWNLOADHISTORYLISTING_REQUEST_END',

    GETALLFLAGGEDFILEDOWNLOADHISTORYLISTING_SUCCESS: 'GETALLFLAGGEDFILEDOWNLOADHISTORYLISTING_SUCCESS',
    GETALLFLAGGEDFILEDOWNLOADHISTORYLISTING_FAILURE: 'GETALLFLAGGEDFILEDOWNLOADHISTORYLISTING_FAILURE'
};